/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import Layout from "../../../../Layouts/Layout";
import DismissalCheckAragPageMeta from "./DismissalCheckAragPageMeta";
import LandingPageTeaser from "../../../../../components/Teaser/LandingPageTeaser";
import TrustSection from "../../../../../components/Sections/Generic/TrustSection/TrustSection";
import Container from "../../../../../components/Container/Container";
import DismissalCheckin from "../../../../../components/Checkin/DismissalCheckin/DismissalCheckin";
import SettlementTimeSection from "../../../../../components/Sections/Settlement/SettlementTimeSection/SettlementTimeSection";
import TeamSection from "../../../../../components/Sections/Generic/TeamSection/TeamSection";
import PartnerLogoSection from "../../../../../components/Sections/Generic/PartnerLogoSection/PartnerLogoSection";
import GreyBackgroundWrapper from "../../../../../components/BackgroundWrapper/GreyBackgroundWrapper";
import { settlementTeaserCards } from "../../../../../services/landingPageService";
import LinkedCardBox from "../../../../../components/LinkedCardBox/LinkedCardBox";
import { useCustomer } from "../../../../../provider/Customer/CustomerProvider";
import HowItWorksSectionSettlement
  from "../../../../../components/Sections/Settlement/HowItWorksSection/HowItWorksSectioSettlement";
import { PARTNER_IRIS } from "../../../../../constants/partnerIris";

const DismissalCheckAragPage = () => {
  const { isLoggedIn } = useCustomer();

  return (
    <Layout backgroundType={"landingpage"}>
      <DismissalCheckAragPageMeta />
      <LandingPageTeaser
        headline={"Kündigung? Jetzt prüfen lassen!"}
        subheadline={"Wir begleiten Sie professionell bei Ihrer Kündigung"}
        hasTeaserButton={true}
        teaserButtonText={"Kostenlos prüfen lassen"}
        teaserButtonLink={isLoggedIn ? "/servicewelt" : "#top-checkin"}
      >
        <LinkedCardBox linkedCards={settlementTeaserCards} />
      </LandingPageTeaser>
      {!isLoggedIn && (
        <Container>
          <DismissalCheckin idPrefix={"top"} partner={PARTNER_IRIS.ARAG} />
        </Container>
      )}
      <PartnerLogoSection partnerIri={PARTNER_IRIS.ARAG} containerStyle={"settlementContainer"} />
      <HowItWorksSectionSettlement />
      <GreyBackgroundWrapper>
        <SettlementTimeSection />
        <TeamSection headline={"Sie möchten professionell gegen Ihre Kündigung angehen?"} subHeadline={"Wir kümmern uns persönlich um Sie"} />
      </GreyBackgroundWrapper>
      <TrustSection />
      {!isLoggedIn && (
        <Container>
          <DismissalCheckin idPrefix={"bottom"} partner={PARTNER_IRIS.ARAG} />
        </Container>
      )}
    </Layout>
  );
};

export default DismissalCheckAragPage;
